import LogRocket from "logrocket";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { authReducer } from "../auth/authState";
import { documentReducer } from "../documents/documentState";

const middlewares = [LogRocket.reduxMiddleware()];

const rootReducer = combineReducers({
  auth: authReducer,
  documents: documentReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default configureStore({
  reducer: rootReducer,
  middleware: middlewares,
});
